import { NewPost } from '@/model/data-object/NewPost'
import useConfiguration from '@/composables/configuration/configuration'
import { Post } from '@/model/data-object/Post'
import useUserFactory from '@/composables/user/userFactory'

export default function usePostFactory() {
  const { configuration } = useConfiguration()
  const { createPubFromObject } = useUserFactory()

  const initPost = function(post?: Post): NewPost {
    if (post) {
      return new NewPost(post.topic.id, post.id)
    }
    return new NewPost(configuration.widget.topicId)
  }

  const updateFromObject = function(post: Post, postProxy: Post): Post {
    post.content = postProxy.content
    if (typeof postProxy.contentRaw !== 'undefined') {
      post.contentRaw = postProxy.contentRaw
    }
    if (
      typeof postProxy.editedAt !== 'undefined' &&
      postProxy.editedAt !== null
    ) {
      post.editedAt = new Date(postProxy.editedAt)
      post.modified = true
    }
    post.topic = postProxy.topic
    post.stats = postProxy.stats
    post.path = postProxy.path
    post.parent = postProxy.parent
    post.pathDesc = postProxy.pathDesc
    post.ipAddress = postProxy.ipAddress
    post.ipAddress = postProxy.ipAddress
    post.status = postProxy.status
    post.createdAt = new Date(postProxy.createdAt)
    post.author = createPubFromObject(postProxy.author)
    post.violations = postProxy.violations

    return post
  }

  const createFromObject = function(postProxy: Post): Post {
    const post = new Post()
    post.id = postProxy.id
    return updateFromObject(post, postProxy)
  }

  return { initPost, createFromObject, updateFromObject }
}
